module.exports = __webpack_public_path__ + "static/media/house-day.8b217cae.svg";